import { useMemo } from 'react'
import { zeroPadding } from 'lib/helper'
import { SelectOption } from 'types/common'

const useTimesWithRange = (defaultStartTime: string, defaultEndTime: string): SelectOption[] => {
  return useMemo(() => {
    const options: SelectOption[] = [{ label: '', value: '' }]

    const startHour = parseInt(defaultStartTime.split(':')[0], 10)
    let startTime = parseInt(defaultStartTime.split(':')[1], 10)
    const endHour = parseInt(defaultEndTime.split(':')[0], 10)
    const endTime = parseInt(defaultEndTime.split(':')[1], 10)

    for (let i = startHour; i <= endHour; i = (i + 1) | 0) {
      for (let j = startTime; j < 60; j = (j + 15) | 0) {
        // 開始時刻をリセット
        if (startTime !== 0) startTime = 0
        const time = `${zeroPadding(i)}:${zeroPadding(j)}`
        options.push({ label: time, value: time })
        // 最終受取時刻を超えたらループを終了
        if (i === endHour && j === endTime) break
      }
    }
    return options
  }, [defaultStartTime, defaultEndTime])
}

export default useTimesWithRange
